import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface UseRunLogListQueryProps {
  companyAutomationId: string;
  page: number;
  count: number;
  sortOrder: string;
  sortField: string;
}
export default function useRunLogListQuery({
  companyAutomationId,
  page,
  count,
  sortOrder,
  sortField
}: UseRunLogListQueryProps) {
  return useQuery({
    queryKey: ['runLogs', companyAutomationId, page, count, sortOrder, sortField],
    queryFn: async () => {
      const GET_RUN_LOG_ENDPOINT =
        '/admin/action/automation/admin/getRunLogs/' + companyAutomationId;
      const { data } = await axios.get(GET_RUN_LOG_ENDPOINT, {
        params: {
          page,
          count,
          sortOrder,
          sortField
        }
      });
      return {
        nodes: data.RUN_LOG.results,
        totalCount: data.RUN_LOG.totalCount
      };
    }
  });
}
